import { MUTATION_TYPES } from './types';
import { initialState } from './state';

export default {
  [MUTATION_TYPES.RESET](state) {
    Object.assign(state, initialState());
  },
  [MUTATION_TYPES.SET_ACADEMIC_YEARS](state, payload) {
    state.catalog.academicYears = payload;
  },
  [MUTATION_TYPES.SET_MONTHS](state, payload) {
    state.catalog.months = payload;
  },
  [MUTATION_TYPES.SET_SPECIALIST](state, payload) {
    state.catalog.specialists = payload;
  },
  [MUTATION_TYPES.SET_CENTERS](state, payload) {
    state.catalog.centers = payload;
  },
  [MUTATION_TYPES.SET_PROVIDERS](state, payload) {
    state.catalog.providers = payload;
  },
  [MUTATION_TYPES.SET_SERVICES](state, payload) {
    state.catalog.services = payload;
  },
  [MUTATION_TYPES.SET_CLEAR_CATALOG](state, payload) {
    state.catalog = {
      ...state.catalog,
      ...payload,
    };
  },
  [MUTATION_TYPES.SET_RESULT](state, payload) {
    state.filter.results = payload.data;

    const visitServiceCount = (payload.data ?? []).reduce(
      (prev, current) => prev + current.visits.length,
      0
    );

    if (!payload.persistSpecialistFilter)
      state.filter.hasResults = payload.data.length > 0;

    //set paging info
    state.paging = {
      count: payload.count,
      currentPage: payload.currentPage,
      pageCount: payload.pageCount,
      totalItemCount: payload.totalItemCount,
    };

    state.filter.specialistInfo = {
      ...state.filter.specialistInfo,
      total: visitServiceCount,
    };
  },
  [MUTATION_TYPES.SET_RESULT_SPECIALIST_INFO](state, payload) {
    const visitServiceCount = (payload.data ?? []).reduce(
      (prev, current) => prev + current.visits.length,
      0
    );

    state.filter.specialistInfo =
      payload.data.length > 0
        ? {
            ...payload.data[0].thrpySpecialistInfo,
            total: visitServiceCount,
            finalizedFlag: payload.data[0].finalizedFlag,
            status: payload.data[0].status,
            selectedService:
              payload.data[0].thrpySpecialistInfo.services.length == 1
                ? payload.data[0].thrpySpecialistInfo.services[0]
                : null,
          }
        : {};
  },
  [MUTATION_TYPES.SET_ADDITIONAL_INFO](state, payload) {
    state.filter = {
      ...state.filter,
      results: state.filter.results.map((item, index) => {
        if (index == payload) {
          item.isOpen = !item.isOpen;
        } else {
          item.isOpen = false;
        }
        return item;
      }),
    };
  },
};
